import React, { useState, useEffect } from 'react';
import { fetchPlaces } from '../utils/api';

interface SearchModalProps {
  onClose: () => void;
  onPlaceSelect: (lat: number, lng: number, name: string) => void;
}

const SearchModal: React.FC<SearchModalProps> = ({ onClose, onPlaceSelect }) => {
  const [term, setTerm] = useState('');
  const [results, setResults] = useState<any[]>([]);

  useEffect(() => {
    if (term.length >= 3) {
      fetchPlaces(term).then(setResults);
    } else {
      setResults([]);
    }
  }, [term]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2>📍 Search for a Location</h2>
        <input
          value={term}
          onChange={e => setTerm(e.target.value)}
          placeholder="Search Place Name"
        />
        <ul>
          {results.map((r, i) => (
            <li key={i} onClick={() => onPlaceSelect(r.lat, r.lng, r.name)}>
              {r.name} ({r.lat}, {r.lng})
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SearchModal;
